import { fromFetch } from 'rxjs/fetch';
import { getListingCounts } from 'constants/routes'
import { switchMap } from 'rxjs';

function getCounts(payload) {
  const url = `${getListingCounts}`;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...payload
      }
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }).pipe(
    switchMap((response) => response.json())
  );
}

export default getCounts;
